var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCinemaInox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 452,
    viewBox: "0 0 800 452",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32335_26872)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 452,
    fill: "#12264F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.329 391.274L717.813 380.66L709.48 373.522L720.489 372.58L724.771 362.57L729.052 372.58L740.061 373.522L731.728 380.66L734.213 391.274L724.771 385.646L715.329 391.274Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.723 234.156L791.208 223.543L782.875 216.405L793.884 215.462L798.165 205.453L802.446 215.462L813.456 216.405L805.122 223.543L807.607 234.156L798.165 228.529L788.723 234.156Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.166 77.1434L724.822 70.0682L719.266 65.3094L726.606 64.68L729.461 58.0078L732.313 64.68L739.653 65.3094L734.099 70.0682L735.755 77.1434L729.461 73.3918L723.166 77.1434Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4481 391.274L80.9634 380.66L89.2966 373.522L78.2875 372.58L74.0061 362.57L69.7248 372.58L58.7156 373.522L67.0488 380.66L64.5642 391.274L74.0061 385.646L83.4481 391.274Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0535 234.156L7.56889 223.543L15.9021 216.405L4.89293 215.462L0.61158 205.453L-3.66977 215.462L-14.6789 216.405L-6.34573 223.543L-8.83038 234.156L0.61158 228.529L10.0535 234.156Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.611 77.1434L73.9548 70.0682L79.5107 65.3094L72.1713 64.68L69.3162 58.0078L66.4636 64.68L59.1242 65.3094L64.6777 70.0682L63.0215 77.1434L69.3162 73.3918L75.611 77.1434Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.609 437.875L402.594 433.484L406 430.531L401.5 430.141L399.75 426L398 430.141L393.5 430.531L396.906 433.484L395.891 437.875L399.75 435.547L403.609 437.875Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.109 35.875L403.094 31.484L406.5 28.531L402 28.141L400.25 24L398.5 28.141L394 28.531L397.406 31.484L396.391 35.875L400.25 33.547L404.109 35.875Z",
    fill: "white",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.557 253.029H317.706L316.971 254.788H315L318.7 246.578H320.599L324.311 254.788H322.298L321.563 253.029H321.557ZM320.954 251.586L319.64 248.444L318.327 251.586H320.96H320.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.926 249.589C336.926 251.442 335.537 252.595 333.315 252.595H331.643V254.888H329.717V246.578H333.315C335.537 246.578 336.926 247.731 336.926 249.595M334.982 249.589C334.982 248.672 334.39 248.141 333.213 248.141H331.649V251.026H333.213C334.39 251.026 334.982 250.489 334.982 249.589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.838 246.578L343.23 254.788H341.329L337.727 246.578H339.815L342.352 252.445L344.919 246.578H346.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.392 254.882L351.799 252.566H350.044V254.882H348.139V246.578H351.709C353.914 246.578 355.291 247.73 355.291 249.593C355.291 250.842 354.668 251.752 353.596 252.216L355.447 254.888H353.398L353.392 254.882ZM351.601 248.146H350.044V251.041H351.601C352.769 251.041 353.356 250.498 353.356 249.593C353.356 248.689 352.769 248.146 351.601 248.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.357 246.578H361.455V254.788H363.357V246.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.569 246.578V254.788H371.99L367.857 249.804V254.788H365.96V246.578H367.55L371.671 251.562V246.578H373.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.571 250.688C375.571 248.215 377.501 246.383 380.127 246.383C382.752 246.383 384.682 248.203 384.682 250.688C384.682 253.173 382.74 254.993 380.127 254.993C377.513 254.993 375.571 253.161 375.571 250.688ZM382.734 250.688C382.734 249.104 381.615 248.021 380.127 248.021C378.638 248.021 377.519 249.104 377.519 250.688C377.519 252.272 378.638 253.354 380.127 253.354C381.615 253.354 382.734 252.272 382.734 250.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.671 254.788L389.666 251.938L387.692 254.788H385.482L388.561 250.614L385.639 246.578H387.825L389.733 249.243L391.61 246.578H393.687L390.789 250.543L393.892 254.788H391.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.907 253.261V254.788H399.499V246.578H405.756V248.104H401.404V249.887H405.245V251.366H401.404V253.261H405.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.221 254.788L411.239 251.938L409.287 254.788H407.108L410.147 250.614L407.257 246.578H409.418L411.311 249.243L413.161 246.578H415.221L412.355 250.543L415.418 254.788H413.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.029 249.589C424.029 251.442 422.64 252.595 420.418 252.595H418.746V254.888H416.82V246.578H420.418C422.64 246.578 424.029 247.731 424.029 249.595M422.079 249.589C422.079 248.672 421.487 248.141 420.31 248.141H418.74V251.026H420.31C421.487 251.026 422.079 250.489 422.079 249.589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.438 253.261V254.788H426.03V246.578H432.282V248.104H427.93V249.887H431.771V251.366H427.93V253.261H432.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.888 254.882L438.301 252.566H436.545V254.882H434.64V246.578H438.211C440.415 246.578 441.793 247.73 441.793 249.593C441.793 250.842 441.17 251.752 440.098 252.216L441.949 254.888H439.9L439.888 254.882ZM438.097 248.146H436.539V251.041H438.097C439.265 251.041 439.852 250.498 439.852 249.593C439.852 248.689 439.265 248.146 438.097 248.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.853 246.578H443.951V254.788H445.853V246.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.865 253.261V254.788H448.457V246.578H454.708V248.104H450.356V249.887H454.197V251.366H450.356V253.261H454.865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.575 246.578V254.788H462.997L458.864 249.804V254.788H456.967V246.578H458.557L462.678 251.562V246.578H464.575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.678 250.682C466.678 248.176 468.6 246.383 471.178 246.383C472.612 246.383 473.811 246.908 474.588 247.856L473.353 248.997C472.799 248.357 472.094 248.025 471.269 248.025C469.714 248.025 468.618 249.118 468.618 250.688C468.618 252.258 469.72 253.351 471.269 253.351C472.1 253.351 472.799 253.018 473.353 252.366L474.588 253.508C473.805 254.468 472.612 254.993 471.166 254.993C468.594 254.993 466.678 253.2 466.678 250.694",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.897 253.261V254.788H476.489V246.578H482.747V248.104H478.395V249.887H482.236V251.366H478.395V253.261H482.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.636 235.259H434.541L450.725 210.853L436.176 188.268H452.964L459.324 200.266L467.796 185H485L467.386 210.853L482.912 235.259H466.028L458.944 222.212L451.636 235.259Z",
    fill: "#EEECDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.018 188.297H315V235.252H330.018V188.297Z",
    fill: "#EEECDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.327 235.252V188.297H352.275L368.015 213.443V188.297H382.379V235.252H368.111L352.716 210.72V235.252H338.327Z",
    fill: "#EEECDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.466 188.297C400.501 188.297 389.989 198.805 389.989 211.771C389.989 224.738 400.501 235.252 413.466 235.252C426.431 235.252 436.944 224.738 436.944 211.771C436.944 198.805 426.431 188.297 413.466 188.297ZM413.466 220.297C408.761 220.297 404.941 216.483 404.941 211.771C404.941 207.06 408.761 203.252 413.466 203.252C418.171 203.252 421.991 207.066 421.991 211.771C421.991 216.477 418.171 220.297 413.466 220.297Z",
    fill: "#EEECDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32335_26872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 452,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinemaInox);
export default __webpack_public_path__ + "static/media/cinema-inox.af97022c594297142aea3195c82a715e.svg";
export { ForwardRef as ReactComponent };